<template>
	<canvas id="gl"></canvas>
	<Loader />
	<div id="cursorElement" :class="{ isModal: !showMenu }">
		<span>watch</span>
	</div>
	<nav class="nav" :class="{ showMenu: showMenu }" v-if="!isMobile">
		<!-- <router-link v-for="(item, id)  in directors" :key="id" :to="`/director/${item.attributes.name}`">{{item.attributes.name}}</router-link> -->
		<!-- <div class="moto" :class="navLocation === 'Director-page' ? 'hide' : ''">
			<img :src="moto" alt="">
		</div> -->
		<div>
			<router-link to="/">
				<svg ref="logo" class="logo" width="81" height="14" viewBox="0 0 81 14" fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<g clip-path="url(#clip0_296_412)">
						<path
							d="M5.65744 0.230957L0.115234 13.7443H3.40217L4.44789 11.0077H9.91427L10.959 13.7443H14.246L8.70472 0.230957H5.65744ZM5.45148 8.36646L7.18155 3.55408L8.91161 8.36646H5.45148Z"
							fill="white" />
						<path
							d="M25.2069 5.78018C24.4214 5.59047 21.4518 5.2862 21.142 5.23304C20.3022 5.08916 19.851 4.80597 19.851 3.98206C19.851 3.15816 20.9444 2.56887 22.5088 2.56887C23.9252 2.56887 24.6967 2.93179 25.0374 3.91791C25.0402 3.92707 25.043 3.93624 25.0458 3.94632H28.2064C27.8394 1.76879 26.0522 0.000915527 22.4507 0.000915527C18.6049 0.000915527 16.7166 2.11246 16.7166 4.22584C16.7166 7.00092 18.677 7.82207 20.4361 8.14742C21.0072 8.25281 23.5161 8.52684 23.8737 8.58458C24.9223 8.75137 25.3033 9.04373 25.3033 9.91896C25.3033 10.8666 24.0572 11.3771 22.6361 11.3771C20.2788 11.3771 19.5832 10.4395 19.5832 8.97774H16.3843C16.637 11.586 17.9393 14.0009 22.6361 14.0009C26.422 14.0009 28.4039 12.1341 28.4039 9.53771C28.4039 7.80374 27.5183 6.26957 25.2069 5.78109V5.78018Z"
							fill="white" />
						<path
							d="M45.4545 10.1967L42.2874 0.755178H39.3188L36.1526 10.1967L34.5218 0.230957H31.5288L33.6568 13.7443H37.6889C37.6889 13.7443 39.9179 6.98534 40.8036 4.5402C41.6892 6.98443 43.9183 13.7443 43.9183 13.7443H47.9504L50.0774 0.230957H47.0844L45.4545 10.1967Z"
							fill="white" />
						<path
							d="M57.008 0.230957L51.4658 13.7452H54.7528L55.7975 11.0086H61.2639L62.3087 13.7452H65.5956L60.0553 0.230957H57.009H57.008ZM56.8021 8.36646L58.5321 3.55408L60.2622 8.36646H56.8021Z"
							fill="white" />

						<path
							d="M77.9794 0.230957V9.69443C77.9148 9.5817 77.8502 9.46989 77.7847 9.36083L71.9794 0.230957H68.1672V13.7443H71.09V4.1672C71.1583 4.28725 71.2286 4.40914 71.3016 4.54112L77.1059 13.7443H80.8844V0.230957H77.9794Z"
							fill="white" />
					</g>
					<defs>
						<clipPath id="clip0_296_412">
							<rect width="80.7692" height="14" fill="white" transform="translate(0.115234)" />
						</clipPath>
					</defs>
				</svg>
			</router-link>
		</div>
		<div class="right">
			<router-link to="/talents">talents</router-link>
			<router-link to="/manifesto">manifesto</router-link>
			<router-link to="/contact">contact</router-link>
			<!-- <router-link  to="/insta">insta</router-link> -->
		</div>
	</nav>
	<nav v-else class="nav" :class="[{ open: menuOpen }, { showMenu: showMenu }]">
		<div class="nav-head" :class="[{ open: menuOpen }]">
			<router-link to="/">
				<svg ref="logo" class="logo" width="81" height="14" viewBox="0 0 81 14" fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<g clip-path="url(#clip0_296_412)">
						<path
							d="M5.65744 0.230957L0.115234 13.7443H3.40217L4.44789 11.0077H9.91427L10.959 13.7443H14.246L8.70472 0.230957H5.65744ZM5.45148 8.36646L7.18155 3.55408L8.91161 8.36646H5.45148Z"
							fill="white" />
						<path
							d="M25.2069 5.78018C24.4214 5.59047 21.4518 5.2862 21.142 5.23304C20.3022 5.08916 19.851 4.80597 19.851 3.98206C19.851 3.15816 20.9444 2.56887 22.5088 2.56887C23.9252 2.56887 24.6967 2.93179 25.0374 3.91791C25.0402 3.92707 25.043 3.93624 25.0458 3.94632H28.2064C27.8394 1.76879 26.0522 0.000915527 22.4507 0.000915527C18.6049 0.000915527 16.7166 2.11246 16.7166 4.22584C16.7166 7.00092 18.677 7.82207 20.4361 8.14742C21.0072 8.25281 23.5161 8.52684 23.8737 8.58458C24.9223 8.75137 25.3033 9.04373 25.3033 9.91896C25.3033 10.8666 24.0572 11.3771 22.6361 11.3771C20.2788 11.3771 19.5832 10.4395 19.5832 8.97774H16.3843C16.637 11.586 17.9393 14.0009 22.6361 14.0009C26.422 14.0009 28.4039 12.1341 28.4039 9.53771C28.4039 7.80374 27.5183 6.26957 25.2069 5.78109V5.78018Z"
							fill="white" />
						<path
							d="M45.4545 10.1967L42.2874 0.755178H39.3188L36.1526 10.1967L34.5218 0.230957H31.5288L33.6568 13.7443H37.6889C37.6889 13.7443 39.9179 6.98534 40.8036 4.5402C41.6892 6.98443 43.9183 13.7443 43.9183 13.7443H47.9504L50.0774 0.230957H47.0844L45.4545 10.1967Z"
							fill="white" />
						<path
							d="M57.008 0.230957L51.4658 13.7452H54.7528L55.7975 11.0086H61.2639L62.3087 13.7452H65.5956L60.0553 0.230957H57.009H57.008ZM56.8021 8.36646L58.5321 3.55408L60.2622 8.36646H56.8021Z"
							fill="white" />

						<path
							d="M77.9794 0.230957V9.69443C77.9148 9.5817 77.8502 9.46989 77.7847 9.36083L71.9794 0.230957H68.1672V13.7443H71.09V4.1672C71.1583 4.28725 71.2286 4.40914 71.3016 4.54112L77.1059 13.7443H80.8844V0.230957H77.9794Z"
							fill="white" />
					</g>
					<defs>
						<clipPath id="clip0_296_412">
							<rect width="80.7692" height="14" fill="white" transform="translate(0.115234)" />
						</clipPath>
					</defs>
				</svg>
			</router-link>
			<button class="burger" :class="[{ open: menuOpen }]" @click="toggleMenu">
				<svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 543.75 543.75">
					<defs>
						<clipPath id="clippath">
							<rect width="543.75" height="543.75" style="fill: none;" />
						</clipPath>
					</defs>
					<g style="clip-path: url(#clippath);">
						<path
							d="m221.31,221.31L0,271.88l221.31,50.57,50.57,221.31,50.57-221.31,221.31-50.57-221.31-50.57L271.88,0l-50.57,221.31Z" />
					</g>
				</svg>
			</button>
		</div>
		<div class="nav-content" :class="{ show: menuOpen }">
			<div class="nav-content-inner">
				<div class="link-list">
					<router-link class=" menuItem delay-1" to="/">Home</router-link>
					<router-link class=" menuItem delay-2" to="/talents">talents</router-link>
					<router-link class=" menuItem delay-3" to="/manifesto">manifesto</router-link>
					<!-- <router-link  to="/contact">contact</router-link> -->
				</div>
				<hr class="delay-4 menuItem ">
				<div class="contact" v-if="contactInfo.mail">
					<!-- <a class="mail delay-4 menuItem " :href="`mailto:${contactInfo.mail.replaceAll('&amp;shy;', '')}`"
						v-html="contactInfo.mail.replace('&amp;shy;', '<br/>')">
					</a> -->

					<div class="menu-block">
						<a v-for="(mail, key) in contactInfo.email" class="mail menuItem" :key="key"
							:class="`delay-${5 + (3 - key)}`" :href="`mailto:${mail.address}`">
							<span class="name domText">{{ mail.name }}</span>
							<span class="address domText">{{ mail.address }}</span>
						</a>
					</div>

					<a class="intagram domText delay-8 menuItem " :href="contactInfo.Link.url" target="_blank"
						rel="noopener">{{ contactInfo.Link.text }}</a>
					<p class="domText delay-8 menuItem " v-html="contactInfo.address.replace('&amp;shy;', '<br />')">
					</p>
				</div>
				<hr class="delay-9 menuItem ">
				<div class="credits delay-9 menuItem"><a href="http://www.charlie-montagut.com" target="_blank"
						rel="noopener">site by charlie</a></div>
			</div>
		</div>
	</nav>

	<div ref="scrollContainer" class="scroll-container">
		<router-view v-slot="{ Component, route }">
			<transition :name="route.meta.transition" mode="out-in">
				<component :is="Component" ref="routerEl" :hideMenu="hideMenu" />
			</transition>
		</router-view>
	</div>
	<div class="videoCollection" v-if="talent">
		<video id="videoContainer" :src="apiUrl + talent.initialCover.data[0].attributes.url" crossorigin="anonymous"
			muted playsinline loop autoplay></video>
		<!-- <video id="videoContainer" src="https://res.cloudinary.com/dx0u7r6hd/video/upload/v1716465538/tempVid_b935ka.mp4" crossorigin="anonymous" muted playsinline loop autoplay></video>
		<video id="videoContainer" src="https://res.cloudinary.com/dx0u7r6hd/video/upload/v1716465538/tempVid_b935ka.mp4" crossorigin="anonymous" muted playsinline loop autoplay></video>
		<video id="videoContainer" src="https://res.cloudinary.com/dx0u7r6hd/video/upload/v1716465538/tempVid_b935ka.mp4" crossorigin="anonymous" muted playsinline loop autoplay></video> -->
	</div>
</template>

<script>
import Loader from './components/Loader'
import { useRoute } from 'vue-router'
import { useRouter } from 'vue-router'
import E from './assets/js/utils/E'
import GlobalEvents from './assets/js/utils/GlobalEvents'
import store from './assets/js/store'
import axios from 'axios';
import Lenis from 'lenis'
import gsap from 'gsap'
import moto from '../src/assets/image/moto.png'
import CursorElement from '@/assets/js/CursorElement'
import ScrollTrigger from 'gsap/ScrollTrigger'
// import showreel from '../video/showreel.pm4'

export default {
  name: 'App',
  components: {
    Loader,
  },
  data: () =>{
	return {
		location: {},
		directors: [],
		navLocation : '',
		appear: false,
		moto: moto,
		showMenu: true,
		isMobile: store.isMobile,
		menuOpen: false,
		contactInfo: {},
		talent: false,
		apiUrl: process.env.VUE_APP_API,

	}
  },
  async created () {
	try {
      const response = await axios.get(`${process.env.VUE_APP_API}/api/directors`)
      this.directors = response.data.data
    } catch (error) {
      this.error = error;
    }
	try {
      const response = await axios.get(`${process.env.VUE_APP_API}/api/contact?populate=*`)
      this.contactInfo = response.data.data.attributes
    } catch (error) {
      this.error = error;
    }
	try {
      const response = await axios.get(`${process.env.VUE_APP_API}/api/talent-page?populate=*`)
      this.talent = response.data.data.attributes
    } catch (error) {
      this.error = error;
    }

	
  },
  mounted() {
	this.location = useRoute();
	this.router =  useRouter();
	ScrollTrigger.defaults({
		scroller: this.$refs.scrollContainer
	})

	E.on('PageLoaded',() => {
		// this.isMobile = store.isMobile
		store.cursor = new CursorElement()
		const vh = store.window.h * 0.01
		document.documentElement.style.setProperty('--vh', `${vh}px`)
		store.Lenis = new Lenis({
			wrapper: this.$refs.scrollContainer,
			// content: document.querySelector('body'),
			gestureOrientation: 'vertical',
			lerp: 0.5,
			syncTouch: true,
			autoResize: true,
			wrapperResizeObserver: this.$refs.scrollContainer
		})
		setTimeout(() => {
			ScrollTrigger.defaults({
				scroller: this.$refs.scrollContainer
			})
		}, 1000)
		
		gsap.ticker.add((time)=>{
			store.Lenis.raf(time * 1000)
			ScrollTrigger.update()
		})

		ScrollTrigger.scrollerProxy(this.$refs.scrollContainer)
		store.Lenis.on('scroll', () => {
			ScrollTrigger.update()
		})


		this.navLocation = this.location.name
		store.MainScene.start()
		E.on(GlobalEvents.RESIZE, this.onResize)

		this.router.afterEach((next, prev) => {
			if(next.fullPath !== prev.fullPath){
				store.Lenis.dimensions.resize()
				setTimeout(() => {
					store.Lenis.scrollTo(0, { immediate: true})
				}, 500)
				ScrollTrigger.defaults({
					scroller: this.$refs.scrollContainer
				})
			}
			// this.$nextTick(() => {
			// 	store.Lenis.dimensions.resize()
			// 	ScrollTrigger.defaults({
			// 		scroller: this.$refs.scrollContainer
			// 	})
			// 	setTimeout(() => {
			

			// 	}, 500)
			// 	// E.emit('PageSwitch')
			// });
		})
		this.router.beforeEach((to, from, next) => {
			if(to.name !== 'Contact-page' && to.name !== 'Manifesto-page' && to.name !== 'Talent-page' ){
				E.emit('introLeave')
			} else {
				E.emit('introEnter', {page: to.name})
			}
			// store.Lenis.scrollTo(0, { immediate: true})
			store.cursor.stop()
			this.navLocation = to.name
			next()
			this.menuOpen = false
		})
	})
  },
  methods: {
	onResize() {
		const vh = store.window.h * 0.01
		document.documentElement.style.setProperty('--vh', `${vh}px`)
	},
	hideMenu(val){
		this.showMenu = !val
	},
	toggleMenu(){
		this.menuOpen = !this.menuOpen
	}
  }
}
</script>

<style lang="less">
@import './assets/less/_imports.less';

#gl {
	position: fixed;
	top: 0;
	left: 0;
	z-index: -1;
}

#cursorElement {
	font-family: @mainFont;
	font-weight: 800;
	position: absolute;
	display: block;
	// transform: translate(-50%, -50%);
	z-index: 1000;
	pointer-events: none;
	color: @white;
	text-transform: uppercase;
	opacity: 0;
	font-size: 12px;

	@media @mobile {
		display: none;
	}

	&::before,
	&:after {
		content: '';
		background-image: url('~@/assets/image/star.svg');
		display: inline-block;
		width: 9px;
		height: 9px;
		position: absolute;
		top: 50%;
		transform-origin: 50% 50%;
	}

	span {
		opacity: var(--opacity);
		padding: 0 3px;

	}

	&:before {
		left: 0;
		transform: translate(-100%, -50%) rotate(var(--rotation)) scale(var(--scaleBefore));
		opacity: var(--scaleBefore);
		// transition: 0.1s;
		background-size: 100%;
	}

	&:after {
		left: 100%;
		transform: translate(0%, -50%) rotate(var(--rotation)) scale(var(--scaleAfter));
		opacity: var(--scaleAfter);
		// transition: 0.1s;
		background-size: 100%;
	}

	&.isModal {
		span {
			display: none;
		}

		&:after,
		&:before {
			transform: translate(-50%, -50%) rotate(var(--rotation)) scale(var(--scaleBefore));
			opacity: 0;
		}
	}

	&.leave {
		&:after {}

		span {}

		&:before {}
	}
}

.nav {
	display: flex;
	justify-content: space-between;
	font-family: @mainFont;
	position: fixed;
	// margin-top: 20px;
	padding: 20px 20px 10px;
	z-index: 100;
	width: calc(100% - 40px);
	transform: translate3d(0, -100%, 0);
	transition: transform 0.5s;
	align-items: center;

	&.showMenu {
		transform: translate3d(0, 0, 0);
	}

	.moto {
		transition: opacity 0.5s;
		opacity: 1;

		&.hide {
			opacity: 0;
		}
	}

	.center {
		position: absolute;
		left: 50%;
		// top: 20px;
		transform: translate(-50%, 3px);

		a {
			font-size: 16px;
		}
	}

	.right {
		a {
			margin-left: 10px;
			font-size: 12px;
		}
	}

	a {
		text-decoration: none;
		color: @white;
		text-transform: uppercase;
	}

	img {

		width: 80px;
	}

	@media @mobile {
		transform: translate3d(0, -100%, 0);
		transition: transform 0.5s;

		&.showMenu {
			transform: translate3d(0, 0, 0);
		}

		&-head {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			z-index: 100;

			svg {
				path {
					fill: @white;
					transition: fill 0.5s;
				}
			}

			button {
				background-color: transparent;
				border: none;
				// background-image: url(./assets/image/star.svg);
				background-size: 100% 100%;
				width: 25px;
				height: 25px;
				transform: rotate(0deg);
				transition: transform 0.5s @ease-InOutSine, background-image 0.5s;
				padding: 0;

				&.open {
					transform: rotate(135deg);
					// background-image: url(./assets/image/star_brown.svg);

				}
			}

			&.open {

				a,
				button {
					color: @darkbrown;

					svg {
						path {
							fill: @darkbrown !important;
						}
					}
				}
			}
		}

		&-content {
			width: 100vw;
			height: 100vh;
			height: calc(var(--vh, 1vh) * 100);
			position: fixed;
			top: 0;
			left: 0;
			overflow: hidden;
			// transform: translate3d(0, -100vh, 0);
			transition: transform 0.5s;
			pointer-events: none;
			color: @darkbrown;

			.menuItem {
				opacity: 0;
				transition: opacity 0.2s;
			}

			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				background-color: white;
				width: 100%;
				height: 100%;
				clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 0% -10%);
				transition: clip-path 0.5s;
			}

			&-inner {
				position: absolute;
				bottom: 0;
				left: 0;
				text-align: left;
				// transform: translate3d(0, 100vh, 0);
				transition: transform 0.5s;
				padding: 0 20px;

				.link-list {
					display: flex;
					flex-direction: column;
					justify-content: start;
					text-align: left;
				}

				a {
					font-size: 35px;
					margin-bottom: 10px;
					color: @darkbrown;
				}
			}

			.contact {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				padding-top: 20px;
				padding-bottom: 16px;

				a,
				.domText {
					font-size: 16px
				}

				.instagram {
					text-align: right;
				}

				.mail,
				.instagram {
					width: 100%;
				}
			}

			.credits {
				padding: 16px 0 24px 0;

				a {
					font-size: 10px;
					font-weight: 700;
				}

			}

			&.show {
				pointer-events: auto;
				// transform: translate3d(0, 0, 0);

				&::before {
					clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
				}

				.menuItem {
					opacity: 1;
					transition: opacity 0s;
				}

				.delay-1 {
					transition-delay: 0.3s
				}

				.delay-2 {
					transition-delay: 0.4s
				}

				.delay-3 {
					transition-delay: 0.5s
				}

				.delay-4 {
					transition-delay: 0.6s
				}

				.delay-5 {
					transition-delay: 0.7s
				}

				.delay-6 {
					transition-delay: .8s
				}

				.delay-7 {
					transition-delay: .9s
				}

				.delay-8 {
					transition-delay: 1s
				}

				.delay-9 {
					transition-delay: 1.1s
				}

				.nav-content-inner {
					// transform: translate3d(0, 0, 0);

				}
			}
		}
	}
}


.menu-block {
	display: flex;
	flex-direction: column-reverse;
	width: 50%;

	.name {
		font-weight: 800;
		display: block;
	}

	.address {
		font-weight: 700;
		display: block;
	}

}

.textCanvas {
	position: absolute;
	top: 0;
	left: 0;
	// background-color: blue;

	width: 100%;
	height: 100%;
	z-index: -1;
	opacity: 1;
}

#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	font-weight: 900;
	//   margin-top: 60px;
}

.lenis.lenis-smooth [data-lenis-prevent] {
	overscroll-behavior: contain;
}

.scroll-container {
	scroll-behavior: auto !important;
	height: 100vh;
	height: calc(var(--vh, 1vh) * 100) !important;
	overflow: hidden;
	position: relative;
	scrollbar-width: none;
	-ms-overflow-style: none;
	overscroll-behavior: none;
	z-index: 10;

	&.isCursor {
		cursor: none;
	}
}

.videoCollection {
	position: fixed;
	top: 0;

	video {
		position: fixed;
		top: 0;

		width: 1px;
	}
}

// .fade-enter-active,
// .fade-leave-active {
// 	opacity: 1;
// 	transition: opacity .5s;
// }

// .fade-enter,
// .fade-leave-to
// 	{
// 	opacity: 0;
// }


.fade-enter-active,
.fade-leave-active {
	transition: all 0.4s;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
	// filter: blur(1rem);
}
</style>
